export default "__VITE_ASSET__$cW$7dyA__"